import React, { useMemo } from 'react'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import MultiRoomHotelCartReviewGroup from './MultiRoomHotelCartReviewGroup'
import CartReviewBanner from './CartReviewBanner'
import useUserCartBedbankHotelItemData from 'hooks/UserCart/useUserCartBedbankHotelItemData'
import useMultiRoomGroupData from 'hooks/UserCart/useMultiRoomGroupData'
import { queryKeyAdults, queryKeyCheckIn, queryKeyCheckOut, queryKeyChildren } from 'constants/url'
import { encodeChildrenOccupancy } from 'lib/search/searchUtils'
import offerPageURL from 'lib/offer/offerPageURL'

interface Props {
  items: Array<App.Checkout.BedbankHotelItem>
  tileVariant?: 'default' | 'condensed'
}

function BedbankCartReviewGroup({ items, tileVariant = 'default' }: Props) {
  const referenceItem = items[0]

  const referenceData = useUserCartBedbankHotelItemData(referenceItem, false)

  const {
    hotelName,
    publicTotalPrice,
    areAllItemsSavedForLater,
    areAllItemsDeleted,
    fetching: cartItemsFetching,
    groupDisabled,
    bannerTypeVariant,
    isAnyItemDeleted,
    handleSaveAllForLater,
    handleDeleteAll,
  } = useMultiRoomGroupData(items, referenceData)

  const offerLink = useMemo(() => {
    const params = new URLSearchParams()
    const rooms = items.map(i => i.occupancy)

    if (!referenceData.isPast) {
      params.set(queryKeyCheckIn, referenceItem.checkIn)
      params.set(queryKeyCheckOut, referenceItem.checkOut)
    }

    params.set(queryKeyAdults, rooms.map(room => room.adults).join(','))
    params.set(queryKeyChildren, rooms.map(room => encodeChildrenOccupancy(room.childrenAge)).join(','))

    return offerPageURL(referenceData.offer, params)
  }, [referenceData.offer, referenceItem, referenceData.isPast, items])

  return (
    <MultiRoomHotelCartReviewGroup
      items={items}
      banner={<CartReviewBanner variant={bannerTypeVariant} to={offerLink} />}
      showOverlay={areAllItemsSavedForLater || groupDisabled}
      hotelName={hotelName}
      checkIn={referenceItem.checkIn}
      checkOut={referenceItem.checkOut}
      duration={referenceItem.duration}
      headerPrice={!!publicTotalPrice && <PriceRowPrice size="S" price={publicTotalPrice} saleUnit="total" signDisplay="never" priceFormat="preciseDollar" />}
      onSaveAllForLater={handleSaveAllForLater}
      onDeleteAll={handleDeleteAll}
      areAllItemsSavedForLater={areAllItemsSavedForLater}
      areAllItemsDeleted={areAllItemsDeleted}
      isAnyItemDeleted={isAnyItemDeleted}
      fetching={cartItemsFetching && referenceData.loading && !referenceData.loaded}
      groupDisabled={groupDisabled}
      tileVariant={tileVariant}
    />
  )
}

export default BedbankCartReviewGroup
